import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormTextField from 'components/FormElements/FormTextField';
import {
  default as TooltipModal,
  TooltipContent,
  TooltipHeader,
} from 'components/Utility/TooltipModal';
import React from 'react';
import { Field } from 'redux-form';
import { Required } from 'utils/validators';
import Checkbox from '../../../../../../../components/Dashboard/Panels/MenuEditor/components/shared/Checkbox';
import { PermissionTypes } from '../../../../../../../utils/constants/permissions';

const rolesList = Object.keys(PermissionTypes).map(i => PermissionTypes[i]);

const UserDetailsForm = ({ active, formValues, handleAttachedPermissions }) => {
  const [selectedPermissions, setSelectedPermissions] = React.useState(
    formValues.permissions || []
  );

  return (
    <div style={{ display: active ? 'block' : 'none' }}>
      <form style={{ display: 'flex', flexDirection: 'column' }}>
        <Field
          name="name"
          type="text"
          margin="normal"
          variant="outlined"
          component={FormTextField}
          validate={[Required]}
          label="Full Name"
        />
        <Field
          name="email"
          type="email"
          margin="normal"
          variant="outlined"
          component={FormTextField}
          validate={[Required]}
          label="Email Address"
        />

        <FormControl>
          <FormLabel classes={{ root: 'input__label marginb__sm' }}>
            Assign Permissions
            <TooltipModal>
              <TooltipHeader
                style={{ marginTop: '30px', marginBottom: '12px' }}
              >
                {' '}
                Assign Permissions
              </TooltipHeader>
              <TooltipContent>
                <p>
                  Assign permissions to this user. Permissions can be assigned
                  to individual users to allow them to access certain parts of
                  the system.
                </p>
              </TooltipContent>
            </TooltipModal>
          </FormLabel>

          {rolesList ? (
            rolesList.map(roles => (
              <Field
                color="primary"
                label={roles.title} // Use 'title' instead of 'name' to display the title
                className="booking__fee__apply"
                name="permissions"
                component={({ input }) => (
                  <Checkbox
                    // disabled={isPaid}
                    {...input}
                    onSelect={() => {
                      const permissionRoot = roles.root; // Use 'root' instead of 'name' to select the root
                      if (selectedPermissions.includes(permissionRoot)) {
                        const updatedMenuIds = selectedPermissions.filter(
                          name => name !== permissionRoot
                        );
                        setSelectedPermissions(updatedMenuIds);
                        handleAttachedPermissions(updatedMenuIds);
                      } else {
                        const updatedPermissionNames = [
                          ...selectedPermissions,
                          permissionRoot,
                        ];
                        setSelectedPermissions(updatedPermissionNames);
                        handleAttachedPermissions(updatedPermissionNames);
                      }
                    }}
                    label={roles.title} // Use 'title' instead of 'name' as the label
                    isChecked={selectedPermissions.includes(roles.root)} // Use 'root' instead of 'name' to check the root
                  />
                )}
              />
            ))
          ) : (
            <p
              style={{
                fontSize: '10px',
              }}
            >
              You have not created any Permissions yet, please create
              Permissions to assign{' '}
            </p>
          )}
        </FormControl>
      </form>
    </div>
  );
};

export default UserDetailsForm;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Users/ViewUsersPanel/UserDetailsModal/UserDetailsForm/index.jsx